export default function stripHtmlTags(html: string) {
  return html
    .replace(/<br ?\/?>/, "\n")
    .replace(/<[^>]*>?/gim, " ")
    .replace(/&nbsp;/gim, " ");
}
